import { GetServerSideProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { TenderPublicPage } from '@web-kc/pages/tender';

export default TenderPublicPage;

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  defaultLocale = 'ru',
}) => {
  return {
    props: {
      ...(await serverSideTranslations(locale ?? defaultLocale, [
        'common',
        'cabinet',
        'tenders',
        'createLot',
        'tenders',
        'lots',
        'lotWinner',
      ])),
    },
  };
};
